import React from 'react';

import { PaymentTypes, useIsAppleOrGooglePay } from '~/features/stripe';
import { toSentenceCase, stripSnakeCase, toTitleCase } from '~/utils/strings';

const PaymentMethodSummary = ({ paymentMethod }) => {
  const isAppleOrGooglePay = useIsAppleOrGooglePay(paymentMethod?.sourceType);
  if (!isAppleOrGooglePay && (!paymentMethod?.last4 || !paymentMethod?.brand)) {
    return null;
  }

  return (
    <span>
      <PaymentSourceIcon
        sourceType={paymentMethod.sourceType?.toLowerCase()}
        brand={paymentMethod.brand?.toLowerCase()}
        isAppleOrGooglePay={isAppleOrGooglePay}
      />
      <PaymentSourceName
        sourceType={paymentMethod.sourceType?.toLowerCase()}
        brand={paymentMethod.brand?.toLowerCase()}
      />{' '}
      {!isAppleOrGooglePay && paymentMethod.last4}
    </span>
  );
};

export default PaymentMethodSummary;

function PaymentSourceName({ sourceType, brand }) {
  const name =
    sourceType === PaymentTypes.CARD
      ? toSentenceCase(brand)
      : toTitleCase(stripSnakeCase(sourceType));
  return <strong>{name}</strong>;
}

function PaymentSourceIcon({ sourceType, brand, isAppleOrGooglePay }) {
  const src = isAppleOrGooglePay
    ? `/icons/${sourceType}.svg`
    : `/icons/cc-${brand || 'credit-card'}.svg`;

  return (
    <img
      alt=""
      src={src}
      style={{
        width: isAppleOrGooglePay ? '3.0rem' : '2.4rem',
        height: 'auto',
        marginRight: '1.6rem',
        verticalAlign: 'text-bottom',
      }}
    />
  );
}
